// Copyright (c) 2020 Deere & Company

import RgaMassUpload from '../../rga/mass-upload/state-connector';

export default {
    component: RgaMassUpload,
    name: 'Mass Upload RGA',
    path: '/rga/mass-upload'
};




// WEBPACK FOOTER //
// ./src/routes/rga/rga-mass-upload.js